<template>
    <v-row class="ma-0 home-section">
        <banner-carousel></banner-carousel>
        <info-section></info-section>
    </v-row>
</template>

<script>
import BannerCarousel from '@/components/Home/banner-carousel';
import InfoSection from '@/components/Home/info-section';
export default {
    name: 'home',
    components: {
        BannerCarousel,
        InfoSection,
    },
    metaInfo() {
        return {
            titleTemplate: `%s | Home`,
        };
    },
    created() {
        this.$store.dispatch('fetchBanners');
    },
};
</script>
<style lang="scss" scoped>
.home-section {
    position: relative;
    background: white;
    min-width: 360px;
}
</style>
